<script>
import { painPoints } from '@site/data/homeContent'
import AppIcon from '@site/components/common/AppIcon.vue'

export default {
  name: 'PainPointsSection',
  components: { AppIcon },
  data() {
    return { painPoints }
  },
}
</script>

<template>
  <section class="section section--light" id="painpoints">
    <div class="container">
      <div class="section-head reveal">
        <span class="section-eyebrow">门店经营痛点</span>
        <h2>让好品味，不再败给繁琐的生意</h2>
        <p>上架、开单、库存、报表，航富通用一套系统替你理顺每一次上新与成交</p>
      </div>

      <div class="grid grid--2">
        <article v-for="(item, i) in painPoints" :key="i" class="card pain-card reveal">
          <div class="pain-card__head">
            <span class="pain-card__badge"><AppIcon :name="item.icon" /></span>
            <h3>{{ item.scene }}</h3>
            <span class="pain-card__num">0{{ i + 1 }}</span>
          </div>

          <div class="pain-card__row">
            <div class="pain-card__cell pain-card__cell--pain">
              <span class="pain-card__label">痛点</span>
              <p>{{ item.pain }}</p>
            </div>
            <span class="pain-card__arrow"><AppIcon name="chevron" :size="16" /></span>
            <div class="pain-card__cell pain-card__cell--solution">
              <span class="pain-card__label">航富通解决</span>
              <p>{{ item.solution }}</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
.pain-card {
  padding: 34px;

  &__head {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 26px;
  }

  &__badge {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.12), rgba(236, 72, 153, 0.12));
    color: $color-primary;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg { width: 22px; height: 22px; }
  }

  h3 { font-size: $font-card; font-weight: $weight-bold; flex: 1; }

  &__num {
    font-family: $font-family-num;
    font-size: 24px;
    font-weight: $weight-black;
    background: $gradient-brand;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -0.02em;
  }

  &__row {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: stretch;
    gap: 10px;
  }

  &__cell {
    border-radius: 14px;
    padding: 14px 16px;

    p { font-size: 14px; line-height: 1.55; margin-top: 5px; font-weight: $weight-medium; }
  }

  &__label { font-size: 12px; font-weight: $weight-semibold; letter-spacing: 0.04em; }

  &__cell--pain {
    background: $color-bg-light;
    border: 1px solid rgba(139, 92, 246, 0.06);

    .pain-card__label { color: $color-text-light; }
    p { color: $color-text-muted; }
  }

  &__cell--solution {
    background: linear-gradient(135deg, $color-primary-soft, $color-secondary-soft);
    border: 1px solid $color-primary-tint;

    .pain-card__label { color: $color-primary; }
    p { color: $color-primary-deep; }
  }

  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-primary;
    opacity: 0.5;
  }

  @media (max-width: $bp-sm) {
    padding: 26px;
    &__row { grid-template-columns: 1fr; }
    &__arrow { transform: rotate(90deg); padding: 4px 0; }
  }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/PainPointsSection.vue